export default __webpack_public_path__ + "static/debug-sp-7fc1e3228fa1e0b6f2863907cfa30558.png";